"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPushPullLoginPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const AdaptableContext_1 = require("@adaptabletools/adaptable/src/View/AdaptableContext");
const PopupRedux = tslib_1.__importStar(require("@adaptabletools/adaptable/src/Redux/ActionsReducers/PopupRedux"));
const IPushPullRedux = tslib_1.__importStar(require("../Redux/ActionReducers/IPushPullRedux"));
const StringExtensions_1 = require("@adaptabletools/adaptable/src/Utilities/Extensions/StringExtensions");
const FormLayout_1 = tslib_1.__importStar(require("@adaptabletools/adaptable/src/components/FormLayout"));
const Input_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/Input"));
const SimpleButton_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/SimpleButton"));
const FlexWithFooter_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/FlexWithFooter"));
const PanelWithImage_1 = require("@adaptabletools/adaptable/src/View/Components/Panels/PanelWithImage");
const PopupContext_1 = require("@adaptabletools/adaptable/src/View/Components/Popups/AdaptablePopup/PopupContext");
const ErrorBox_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/ErrorBox"));
const HelpBlock_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/HelpBlock"));
const rebass_1 = require("rebass");
const IPushPullLoginComponent = (props) => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    const options = adaptable.getPlugin('ipushpull').options;
    const [state, setState] = React.useState({
        Login: options.username || '',
        Password: options.password || '',
    });
    const { hidePopup } = (0, PopupContext_1.usePopupContext)();
    const onSubmit = () => {
        props.onLogin(state.Login || '', state.Password || '');
    };
    const onLoginChange = (event) => {
        const e = event.target;
        setState(Object.assign(Object.assign({}, state), { Login: e.value }));
    };
    const onPasswordChange = (event) => {
        const e = event.target;
        setState(Object.assign(Object.assign({}, state), { Password: e.value }));
    };
    return (React.createElement(PanelWithImage_1.PanelWithImage, { header: "ipushpull Login Details", glyphicon: "login", variant: "primary", style: { height: '100%' } },
        React.createElement(FlexWithFooter_1.default, { as: "form", onSubmit: (e) => {
                e.preventDefault();
                onSubmit();
            }, footerProps: {
                fontSize: 'var(--ab-font-size-4)',
            }, footer: React.createElement(React.Fragment, null,
                React.createElement(SimpleButton_1.default, { tone: "neutral", variant: "text", tooltip: "Close", onClick: (e) => {
                        e.stopPropagation();
                        hidePopup();
                    } }, "CLOSE"),
                React.createElement("div", { style: { flex: 1 } }),
                React.createElement(SimpleButton_1.default, { tone: "accent", variant: "raised", type: "submit", disabled: StringExtensions_1.StringExtensions.IsNullOrEmpty(state.Password), icon: 'check' }, "Login")) },
            React.createElement(rebass_1.Flex, { flexDirection: "column", padding: 2, margin: 2 },
                React.createElement(HelpBlock_1.default, { marginBottom: 1 }, "Login to ipushpull using your login (email address) and password."),
                React.createElement(FormLayout_1.default, { margin: 3 },
                    React.createElement(FormLayout_1.FormRow, { label: "ipushpull login:" },
                        React.createElement(Input_1.default, { width: "100%", type: "email", placeholder: "Email address", value: state.Login, onChange: onLoginChange })),
                    React.createElement(FormLayout_1.FormRow, { label: "ipushpull password:" },
                        React.createElement(Input_1.default, { width: "100%", type: "password", placeholder: "Password", value: state.Password, onChange: onPasswordChange })),
                    props.pushpullLoginErrorMessage ? (React.createElement(FormLayout_1.FormRow, { label: "" },
                        React.createElement(ErrorBox_1.default, null, props.pushpullLoginErrorMessage))) : null)))));
};
function mapStateToProps(state) {
    return {
        // pushpullLogin: state.IPushPull ? state.IPushPull!.Username : undefined,
        // pushpullPassword: state.IPushPull ? state.IPushPull!.Password : undefined,
        // pushpullLoginErrorMessage: state.IPushPull.IPushPullLoginErrorMessage,
        pushpullLoginErrorMessage: state.System.IPushPullLoginErrorMessage,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onLogin: (login, password) => dispatch(IPushPullRedux.IPushPullLogin(login, password)),
        onCancel: () => {
            dispatch(PopupRedux.PopupHideScreen());
            dispatch(IPushPullRedux.IPushPullSetLoginErrorMessage(''));
        },
    };
}
exports.IPushPullLoginPopup = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(IPushPullLoginComponent);
